module.exports = __webpack_public_path__ + "img/melaka.dc9f5d8e.png";